"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDivinationEventCallbacks = createDivinationEventCallbacks;
var context_1 = require("../context");
function createDivinationEventCallbacks(contextRef) {
    return {
        ai_enriched_document_received: function (documentType, documentInfo, uiElement) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_enriched_document_received', __assign(__assign({}, (0, context_1.buildInChatContextProperties)(ctx)), { enriched_document_type: documentType, enriched_document_info: documentInfo, ui_element: uiElement }));
        },
    };
}
